import "./SideGallery.css";

const SideGallery = ({ mainImg, header = '', galleryArr = [], children}) => {
  return (
    <div className="sideGallery">
      <img alt="" className="galleryMainImg" src={mainImg} />
      <div className="galleryHeader">{header && header}</div>
      <div className="gallery">
        {galleryArr.map((el, i) => {
          return <img alt="" src={el.img} key={i} />;
        })}
        {children && children}
      </div>
    </div>
  );
};

export default SideGallery;
